import dayjs from 'dayjs';
import numeral from 'numeral';



export const formatDate = (date) => {
  let dt = new Date(date.replace(/-/g, '\/').replace(/T.+/, ''));
  let month = dt.toLocaleString("default", {
    month: "long"
  });
  let day = dt.getDate() > 9 ? dt.getDate() : ('0' + dt.getDate());
  let fullYear = dt.getFullYear();
  return `${month} ${day} ${fullYear}`;
};

export const formatShortDate = (date) => {
  return dayjs(date).format('MM/DD/YY');
  // return dayjs.utc(date).8
};

export const formatLongDate = (date) => {
  return dayjs(date).add(1, 'day').format('MMMM DD, YYYY');
};

export const formatCurrencyNum = (num) => {
  return numeral(num).format('$ 0,0.00');
};

export const formatPercentage = (num) => {
  return numeral(num).format('0 %');
};